"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";

const STORAGE_KEY = "tippo-theme";

/**
 * Wraps the app with next-themes so html gets class="dark" when appropriate.
 * Defaults to system preference; persists user choice in localStorage.
 */
export function ThemeProvider({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      storageKey={STORAGE_KEY}
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
